import React, { useState, useEffect } from "react";

import heartImg from "../assets/Heart.png";
import lungImg from "../assets/lungs.png";
import bodyImg from "../assets/Body.png";
import { formatSleep } from "../utils/format";

export default function HealthOverviewCard({ data, onTabChange }) {
  const [tab, setTab] = useState("heart");

  // Inform parent about active tab
  useEffect(() => {
    if (onTabChange) onTabChange(tab);
  }, [tab]);

  const images = {
    heart: heartImg,
    lung: lungImg,
    body: bodyImg,
  };

  // ⭐ Extract dynamic API data
  const heartData = {
    heartRate: data?.health_metrics?.heart_rate?.value ?? "--",
    spo2: data?.health_metrics?.spo2?.value ?? "--",
    bpSystolic: data?.health_metrics?.bp?.systolic ?? "--",
    bpDiastolic: data?.health_metrics?.bp?.diastolic ?? "--",
    heartLabel: data?.health_metrics?.heart_rate?.label ?? "",
  };

  const lungData = {
    lungLabel: data?.health_metrics?.lung_sound?.label ?? "No Data",
    lungConfidence: data?.health_metrics?.lung_sound?.confidence ?? "--",
    spo2: data?.health_metrics?.spo2?.value ?? "--",
  };

  const bodyData = {
    weight: data?.patient?.health_profile?.weight ?? "--",
    height: data?.patient?.health_profile?.height ?? "--",
    bmi: data?.health_metrics?.bmi?.value ?? "--",
    bmiLabel: data?.health_metrics?.bmi?.label ?? "",
    steps: data?.health_metrics?.steps_data ?? "--",
    sleep: data?.health_metrics?.sleep_data? formatSleep(data.health_metrics.sleep_data): "--",
    hrv: data?.health_metrics?.hrv ?? "--",
  };

  // Pick dynamic content based on selected tab
  const details = {
    heart: heartData,
    lung: lungData,
    body: bodyData,
  };

  return (
    <div className="overview-card">
      <h2 className="overview-title">Your Health Overview</h2>

      {/* TAB BUTTONS */}
      <div className="overview-tabs">
        <button
          className={tab === "heart" ? "tab active" : "tab"}
          onClick={() => setTab("heart")}
        >
          Heart Health
        </button>

        <button
          className={tab === "lung" ? "tab active" : "tab"}
          onClick={() => setTab("lung")}
        >
          Lung Health
        </button>

        <button
          className={tab === "body" ? "tab active" : "tab"}
          onClick={() => setTab("body")}
        >
          Body Health
        </button>
      </div>

      {/* IMAGE */}
      <div className="overview-image-box">
        <img
          src={images[tab]}
          alt={tab}
          className="overview-image"
        />
      </div>

      {/* DYNAMIC TEXT VALUES */}
      {/* <div className="overview-details">
        {tab === "heart" && (
          <>
            <p>Heart Rate: <strong>{details.heart.heartRate}</strong></p>
            <p>Blood Pressure: <strong>{details.heart.bpSystolic}/{details.heart.bpDiastolic}</strong></p>
            <p>SpO₂: <strong>{details.heart.spo2}%</strong></p>
            <p>Status: <strong>{details.heart.heartLabel}</strong></p>
          </>
        )}

        {tab === "lung" && (
          <>
            <p>Lung Status: <strong>{details.lung.lungLabel}</strong></p>
            <p>Confidence: <strong>{details.lung.lungConfidence}</strong></p>
            <p>SpO₂: <strong>{details.lung.spo2}%</strong></p>
          </>
        )}

        {tab === "body" && (
          <>
            <p>Weight: <strong>{details.body.weight} kg</strong></p>
            <p>Height: <strong>{details.body.height} cm</strong></p>
            <p>BMI: <strong>{details.body.bmi}</strong> ({details.body.bmiLabel})</p>
            <p>Steps: <strong>{details.body.steps}</strong></p>
            <p>Sleep: <strong>{details.body.sleep} mins</strong></p>
          </>
        )}
      </div> */}
    </div>
  );
}
